"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Web3InterfaceAdapter = void 0;

var bn_js_1 = __importDefault(require("bn.js"));

var shim_1 = require("../../shim");

var Web3InterfaceAdapter = /*#__PURE__*/function () {
  function Web3InterfaceAdapter() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        provider = _ref.provider,
        networkType = _ref.networkType;

    _classCallCheck(this, Web3InterfaceAdapter);

    this.web3 = new shim_1.Web3Shim({
      provider: provider,
      networkType: networkType
    });
  }

  _createClass(Web3InterfaceAdapter, [{
    key: "getNetworkId",
    value: function getNetworkId() {
      return this.web3.eth.net.getId();
    }
  }, {
    key: "getBlock",
    value: function getBlock(block) {
      return this.web3.eth.getBlock(block);
    }
  }, {
    key: "getTransaction",
    value: function getTransaction(tx) {
      return this.web3.eth.getTransaction(tx);
    }
  }, {
    key: "getTransactionReceipt",
    value: function getTransactionReceipt(tx) {
      return this.web3.eth.getTransactionReceipt(tx);
    }
  }, {
    key: "getBalance",
    value: function getBalance(address) {
      return this.web3.eth.getBalance(address);
    }
  }, {
    key: "getCode",
    value: function getCode(address) {
      return this.web3.eth.getCode(address);
    }
  }, {
    key: "getAccounts",
    value: function getAccounts() {
      return this.web3.eth.getAccounts();
    }
  }, {
    key: "estimateGas",
    value: function estimateGas(transactionConfig) {
      var stacktrace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var gasEstimate;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(stacktrace === true)) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return this.web3.eth.estimateGas(transactionConfig);

              case 4:
                gasEstimate = _context.sent;
                return _context.abrupt("return", gasEstimate);

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                return _context.abrupt("return", null);

              case 11:
                _context.next = 14;
                break;

              case 13:
                return _context.abrupt("return", this.web3.eth.estimateGas(transactionConfig));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 8]]);
      }));
    }
  }, {
    key: "getBlockNumber",
    value: function getBlockNumber() {
      return this.web3.eth.getBlockNumber();
    }
  }, {
    key: "getTransactionCostReport",
    value: function getTransactionCostReport(receipt) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var tx, block, balance, gasPrice, gas, value, cost;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getTransaction(receipt.transactionHash);

              case 2:
                tx = _context2.sent;
                _context2.next = 5;
                return this.getBlock(receipt.blockNumber);

              case 5:
                block = _context2.sent;

                if (block) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", null);

              case 8:
                _context2.next = 10;
                return this.getBalance(tx.from);

              case 10:
                balance = _context2.sent;
                gasPrice = new bn_js_1.default(tx.gasPrice);
                gas = new bn_js_1.default(receipt.gasUsed);
                value = new bn_js_1.default(tx.value);
                cost = gasPrice.mul(gas).add(value);
                return _context2.abrupt("return", {
                  timestamp: block.timestamp,
                  from: tx.from,
                  balance: shim_1.Web3Shim.utils.fromWei(balance, "ether"),
                  gasUnit: "gwei",
                  gasPrice: shim_1.Web3Shim.utils.fromWei(gasPrice, "gwei"),
                  gas: gas,
                  valueUnit: "ETH",
                  value: shim_1.Web3Shim.utils.fromWei(value, "ether"),
                  cost: cost
                });

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "displayCost",
    value: function displayCost(value) {
      return shim_1.Web3Shim.utils.fromWei(value, "ether");
    }
  }]);

  return Web3InterfaceAdapter;
}();

exports.Web3InterfaceAdapter = Web3InterfaceAdapter;